import { SettingsRow, SettingsSection } from './SettingsControls'
import { useSettingsForm } from './useSettingsForm'

export function SettingsImportTab() {
  const { draft, set } = useSettingsForm()

  return (
    <>
      <SettingsSection
        title="Batch Processing"
        help="Configure how records are sent to QuickBooks."
      >
        {/* Not the QuickBooks request size: IntuitQboClient re-chunks every call
            to 30 operations, Intuit's hard limit. This is the outer loop — how
            many rows are written between progress saves and error-rate checks. */}
        <SettingsRow
          htmlFor="batchSize"
          label="Batch Size"
          help="How many rows are processed before progress is saved and the error rate is re-checked. Smaller batches report progress and stop on a bad file sooner; larger ones finish slightly faster."
        >
          <input
            className="bb-input"
            id="batchSize"
            type="number"
            min={1}
            max={100}
            value={draft.batchSize}
            onChange={(event) => set('batchSize', Number(event.target.value))}
          />
        </SettingsRow>
      </SettingsSection>

      <SettingsSection
        title="Error Handling"
        help="Define how the system responds to errors during import."
      >
        {/* ExceedsErrorRate is `errors * 100 > percent * settled`, so 0 aborts on
            the first failure and empty never aborts. Two different things, and
            the field cannot say so on its own. */}
        <SettingsRow
          htmlFor="stopOnError"
          label="Error Rate Limit"
          help="Stop the import if the share of failed rows exceeds this percentage. Set it to 0 to stop at the first failed row, or leave it empty to process every row regardless of errors."
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              className="bb-input"
              id="stopOnError"
              type="number"
              min={0}
              max={100}
              placeholder="Never stop"
              style={{ maxWidth: 120 }}
              value={draft.stopOnErrorRatePercent ?? ''}
              onChange={(event) =>
                set(
                  'stopOnErrorRatePercent',
                  event.target.value === '' ? null : Number(event.target.value),
                )
              }
            />
            <span>%</span>
          </div>
        </SettingsRow>
      </SettingsSection>
    </>
  )
}
